import * as React from 'react';
import type { TabKey } from '~/Partials/TabList/Tab';
import { buildTabId, buildTabPanelId } from '~/Partials/Tabs/tabUtils';

export interface TabPanelProps {
    tabKey: TabKey;
    className?: string;
}

export const TabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = props => {
    const { tabKey, className, children } = props;

    return (
        <div id={buildTabPanelId(tabKey)} className={className} role="tabpanel" aria-labelledby={buildTabId(tabKey)}>
            {children}
        </div>
    );
};
